import type { NotificationFooterActionItem, NotificationItem } from '@/services/notification/type';
import { PricingModalOrigin } from '@wegic/price-ui';
import { openFeedbackModal } from '@/components/FeedbackModal';
import { FeedbackSource } from '@/components/FeedbackModal/const';
import { DEFAULT_PATH_AFTER_LOGIN } from '@/const';
import { openPricingModal } from '@/helpers/pricingModal';
import { openSettingsModal, SettingsModalSource, SettingsTab } from '@/helpers/settingsModal';

interface NotificationActionContext {
  navigate: (path: string) => void;
  onClose?: () => void;
}

export function handleNotificationAction(
  item: NotificationItem,
  action: NotificationFooterActionItem,
  ctx: NotificationActionContext,
) {
  if (action.type === 'external_url') {
    if (action.url) {
      window.open(action.url, '_blank', 'noopener,noreferrer');
    }
    return;
  }

  requestAnimationFrame(() => {
    switch (action.type) {
      case 'feedback':
        ctx.onClose?.();
        openFeedbackModal(FeedbackSource.NotificationDetail, {
          context: {
            notificationId: item.id,
            notificationTitle: item.title,
          },
        });
        return;
      case 'get_started':
        ctx.navigate(DEFAULT_PATH_AFTER_LOGIN);
        return;
      case 'upgrade':
        openPricingModal({ origin: PricingModalOrigin.InviteNotice });
        return;
      case 'view_credits':
        openSettingsModal({
          initialTab: SettingsTab.Usage,
          source: SettingsModalSource.NotificationCreditsUsage,
        });
    }
  });
}
